<mat-list-item
	class="location-input ion-margin"
	lines="none">
	<input
		matInput
		type="text"
		placeholder="Expected location" />
	<mat-icon
		slot="end"
		color="primary"
		>location_on</mat-icon
	>
</mat-list-item>
<mat-label class="ion-margin">Accepted radius (KM)</mat-label>
<mat-list-item lines="none">
	<mat-slider
		min="2"
		max="100"
		step="1"
		pin="true"
		class="mat-padding-none">
		<mat-label slot="start">0</mat-label>
		<mat-label slot="end">100</mat-label>
	</mat-slider>
</mat-list-item>
<div class="btn-section">
	<button
		class="btn secondary-btn"
		expand="full"
		>CANCEL</button
	>
	<button
		class="btn primary-btn"
		expand="full"
		>SAVE</button
	>
</div>
